import request from '../request'
import { BASE_API } from '../Constant'
// @todo this file name should be product service
const baseUrl = `${BASE_API}cms`
// const baseApi = `${BASE_API}`
function secoundSection() {
  return request({
    url: `${baseUrl}/main_secound_section`,
    method: 'GET',
  })
}
function centerSection() {
  return request({
    url: `${baseUrl}/home_center_section`,
    method: 'GET',
  })
}
function bottomSection() {
  return request({
    url: `${baseUrl}/home_bottom_section`,
    method: 'GET',
  })
}
function mainSection() {
  return request({
    url: `${baseUrl}/main_manner`,
    method: 'GET',
  })
}
function aboutSection() {
  return request({
    url: `${baseUrl}/about_top_section`,
    method: 'GET',
  })
}
function aboutBottomSection() {
  return request({
    url: `${baseUrl}/about_bottom_section`,
    method: 'GET',
  })
}
// function getProductById(id) {
//   return request({
//     url: `${baseUrl}/show/${id}`,
//     method: 'GET',
//   })
// }


const CmsService = {
    secoundSection,
    centerSection,
    bottomSection,
    mainSection,
    aboutSection,
    aboutBottomSection
//   getProductById
}

export default CmsService
